import React from "react";
import PropTypes from "prop-types";
import { formatNumber, pluralize } from "@wrstudios/utils";
import { getAverageDOM } from "../../../utils/listings";
import IllustrationTimeToSell from "../../illustrations/IllustrationTimeToSell";
import { useLive } from "../LiveProvider";
import Preview from "./LivePreview";

function LivePreviewTimeToSell({ title }) {
  const { visibleListings } = useLive();
  const soldListings = visibleListings.filter((listing) => listing.soldPrice);
  const averageDOM = getAverageDOM(soldListings);

  return (
    <Preview
      illustration={<IllustrationTimeToSell />}
      title={title}
      subTitle={
        averageDOM
          ? `${formatNumber(averageDOM)} ${pluralize(
              "Days",
              averageDOM
            )} on Market`
          : "N/A"
      }
    />
  );
}

LivePreviewTimeToSell.propTypes = {
  title: PropTypes.string.isRequired
};

export default LivePreviewTimeToSell;
